import { EstimationType } from './estimation-type.model';
import { Main } from './general-responses.model';
import { Priority } from './priority.model';
import { ProjectsList } from './projects.model';
import { Provider } from './provider.model';
import { RequisitionColumn, RequisitionFilters, UsersWho } from './requisition.model';
import { Status } from './status.model';
import { Company, User } from './user.model';

export interface EstimationResponse extends Main {
  response: EstimationData | UsersWho | EstimationFilters | Estimation | BasicEstimationFromApi | FullEstimationFromApi | boolean;
}

export interface EstimationData {
  limit: number;
  page: number;
  total: number;
  rows: EstimationFromApi[];
}

export interface Estimation {
  estimationId: number;
  estimationKey: string;
  estimationFolio: number;
  estimationDescription: string;
  estimationApplicationDate: Date;
  estimationType: Status;
  userWhoAuthorizes: User;
  userWhoRequests: User;
  userWhoBuys: User;
  userWhoReviews: User;
  project: ProjectsList;
  supplier: Provider;
  estimationPriority: Priority;
  estimationStatus: Status;
  estimationProgress: Status;
  isAuthorized: boolean;
  totalCost: number;
  estimationIsHighlighted: boolean;
  estimationNotes: string;
  paymentMethod: number;
  periodStart: string;
  periodEnd: string;
  workPrepayment: number;
  workPrepaymentRefund: number;
  company: Company;
  dataField?: string;
}

export interface EstimationFromApi {
  id: number;
  key: string;
  project: ProjectsList;
  folio: number;
  description: string;
  notes: string;
  statementDate: string;
  totalCost: number;
  paymentMethod: number;
  periodStart: string;
  periodEnd: string;
  workPrepayment: number;
  workPrepaymentRefund: number;
  isFeatured: boolean;
  priority: number;
  priorityInfo: Priority;
  status: number;
  statusInfo: Status;
  currentState: number;
  currentProgressInfo: Status;
  type: number;
  type_Info: Status;
  supplier: Provider;
  createdBy: User;
  authorizedBy: User;
  reviewedBy: User;
  company: Company;
}

export interface BasicEstimationFromApi {
  ID: number;
  Prepayment: number;
  accountId: number;
  advancePayment: number;
  advanceRetention: number;
  canceledByID: number;
  cancellationReason: string;
  cancelledAt: Date;
  companyID: number;
  createdAt: Date;
  createdByID: number;
  currentProgress: number;
  currentProgressLabel: string;
  description: string;
  folioNumber: number;
  include: number;
  invoiced: number;
  isAnAdvancePayment: boolean;
  isCancelled: boolean;
  isFeatured: boolean;
  isRejected: boolean;
  isSentToTreasury: boolean;
  netAmount: number;
  notes: string;
  paid: number;
  paymentMethod: number;
  periodEndDate: Date;
  periodStartDate: Date;
  priority: number;
  priorityLabel: string;
  projectID: number;
  projectName: string;
  rejectedAt: Date;
  rejectedByID: number;
  rejectionReason: string;
  reviewed: number;
  sFolio: string;
  statementDate: Date;
  status: number;
  statusLabel: string;
  subProjectID: number;
  subTotal: number;
  subcontractAgreementID: number;
  supplierID: number;
  type: number;
  typeLabel: string;
  updatedAt: Date;
  vatAmount: number;
  vatPercentage: number;
  warrantyRefund: number;
  warrantyRetention: number;
  warrantyRetentionPercentage: number;
  workPrepayment: number;
  workPrepaymentRefund: number;
}
export interface FullEstimationFromApi {
  Company: {
    clave: string;
    id: number;
    razonSocial: string;
  };
  CreatedBy: {
    APELLIDOS: string;
    AUTORIZAEST: number;
    AUTORIZAREQS: number;
    ESADMINISTRADOR: number;
    Image: string;
    NOMBRES: string;
    NombreCompleto: string;
    PERFILIDS: number;
    Permisos: string[];
    Role: string;
    USUARIO: string;
    USUARIOID: number;
    VERIMPORTES: number;
  };
  ID: number;
  Prepayment: number;
  Project: {
    DatosAdicionales: string;
    EmpresaDelProyecto: string;
    clave: string;
    descripcion: string;
    direccion: string;
    empresaId: number;
    estado: number;
    fechaFin: Date;
    fechaIni: Date;
    id: number;
    importeDeControl: number;
    presupuestoBase: number;
  };
  Supplier: {
    apellidos: string;
    clave: string;
    email: string;
    forma_de_pago: number;
    id: number;
    nombres: string;
    razon_social: string;
  };
  accountId: number;
  advancePayment: number;
  advanceRetention: number;
  canceledByID: number;
  cancellationReason: string;
  cancelledAt: Date;
  companyID: number;
  createdAt: Date;
  createdByID: number;
  currentProgress: number;
  currentProgressLabel: string;
  description: string;
  folioNumber: number;
  include: number;
  invoiced: number;
  isAnAdvancePayment: boolean;
  isCancelled: boolean;
  isFeatured: boolean;
  isRejected: boolean;
  isSentToTreasury: boolean;
  netAmount: number;
  notes: string;
  paid: number;
  paymentMethod: number;
  periodEndDate: Date;
  periodStartDate: Date;
  priority: number;
  priorityLabel: string;
  projectID: number;
  projectName: string;
  rejectedAt: Date;
  rejectedByID: number;
  rejectionReason: string;
  reviewed: number;
  sFolio: string;
  statementDate: Date;
  status: number;
  statusLabel: string;
  subProjectID: number;
  subTotal: number;
  subcontractAgreementID: number;
  supplierID: number;
  type: number;
  typeLabel: string;
  updatedAt: Date;
  vatAmount: number;
  vatPercentage: number;
  warrantyRefund: number;
  warrantyRetention: number;
  warrantyRetentionPercentage: number;
  workPrepayment: number;
  workPrepaymentRefund: number;
}
export interface FullEstimation {
  company: {
    key: string;
    ID: number;
    businessName: string;
  };
  createdBy: {
    lastName: string;
    authorizeEstimations: number;
    authorizeRequisitions: number;
    isAdministrator: number;
    image: string;
    firstName: string;
    fullName: string;
    profileIDS: number;
    permissions: string[];
    role: string;
    user: string;
    userID: number;
    viewAmounts: number;
  };
  ID: number;
  prepayment: number;
  project: {
    additionalData: string;
    projectCompany: string;
    key: string;
    description: string;
    address: string;
    companyID: number;
    status: number;
    endDate: Date;
    startDate: Date;
    ID: number;
    controlAmount: number;
    basebudget: number;
  };
  supplier: {
    lastName: string;
    key: string;
    email: string;
    paymentMethod: number;
    ID: number;
    firstName: string;
    businessName: string;
  };
  accountID: number;
  advancePayment: number;
  advanceRetention: number;
  canceledByID: number;
  cancellationReason: string;
  cancelledAt: Date;
  companyID: number;
  createdAt: Date;
  createdByID: number;
  currentProgress: number;
  currentProgressLabel: string;
  description: string;
  folioNumber: number;
  include: number;
  invoiced: number;
  isAnAdvancePayment: boolean;
  isCancelled: boolean;
  isFeatured: boolean;
  isRejected: boolean;
  isSentToTreasury: boolean;
  netAmount: number;
  notes: string;
  paid: number;
  paymentMethod: number;
  periodEndDate: Date;
  periodStartDate: Date;
  priority: number;
  priorityLabel: string;
  projectID: number;
  projectName: string;
  rejectedAt: Date;
  rejectedByID: number;
  rejectionReason: string;
  reviewed: number;
  sFolio: string;
  statementDate: Date;
  status: number;
  statusLabel: string;
  subProjectID: number;
  subTotal: number;
  subcontractAgreementID: number;
  supplierID: number;
  type: number;
  typeLabel: string;
  updatedAt: Date;
  vatAmount: number;
  vatPercentage: number;
  warrantyRefund: number;
  warrantyRetention: number;
  warrantyRetentionPercentage: number;
  workPrepayment: number;
  workPrepaymentRefund: number;
  dataField?: string;
}

export interface EstimationFilters extends RequisitionFilters {
  totalCostFilter?: number | null;
  totalCostType?: number | null;
  wpsPriorities?: Priority[];
  wpsProgress?: Status[];
  wpsStatus?: Status[];
  wpsType: string[];
  estimationApplicationDate?: Date[];
  wpsSupplier?: number[];
  wpsCreatedBy?: number[];
  wpsAuthorizedBy?: number[];
  wpsReviewedBy?: number[];
  wpsID?: number[];
}

export interface SelectableEstimation {
  estimationId: number;
  estimationDescription: string;
  isSelected: boolean;
  isIdTooltipVisible: boolean;
  isFolioTooltipVisible: boolean;
}

export interface EstimationColumn extends RequisitionColumn {}

export enum EstimationColumnEnum {
  Project = 0,
  ProviderName = 1,
  EstimationFolio = 2,
  EstimationKey = 3,
  EstimationDescription = 4,
  EstimationApplicationDate = 5,
  UserWhoRequests = 6,
  EstimationType = 7,
  TotalCost = 8,
  EstimationPriority = 9,
  EstimationStatus = 10,
  EstimationProgress = 11,
}

export enum DashboardEstimationColumnEnum {
  Project = 0,
  ProviderName = 1,
  EstimationFolio = 2,
  EstimationDescription = 3,
  EstimationApplicationDate = 4,
  UserWhoRequests = 5,
  TotalCost = 6,
  estimationPriority = 7,
  EstimationProgress = 8,
}

export enum EstimationProgressEnum {
  'Iniciado',
  'Por revisar',
  'Por autorizar',
  'Por enviar a pagos',
  'Enviado a pagos',
  'En proceso de pago',
  'Pagada',
  'Rechazada',
  'Cancelada',
}